// Defines a plugin to get configuration from the server
import { getClientConfiguration } from "@ckweb/ckfetch/connectables/configuration";
import { defineNuxtPlugin } from "nuxt/app";

declare global {
  interface Window {
    ckVersion: () => string;
  }
}

const PROTECTED_KEYS = [
  "API_URL",
  "apiUrl",
  "SENTRY_RELEASE",
  "BUILD_TIMESTAMP",
];
export default defineNuxtPlugin({
  name: "ckweb:settings",
  dependsOn: ["ckweb:common"],
  setup: async (nuxtApp) => {
    const publicConfig = nuxtApp.$config.public;

    const VERSION_STRING = `Version: ${publicConfig.VERSION}, Built At: ${publicConfig.BUILD_TIMESTAMP}`;

    if (import.meta.client) {
      window.ckVersion = function () {
        console.info(VERSION_STRING);
        return VERSION_STRING;
      };
    }

    const response = await getClientConfiguration({
      baseUrl: String(publicConfig.API_URL),
    }).catch((e) => {
      console.error(e);
      console.dir(e);
    });

    // Go through the values and add/override settings
    const protectedKeys = new Set(PROTECTED_KEYS);
    if (!import.meta.env.PROD) {
      // Prevent local protected keys from being overridden in non-production environments (e.g localhost)
      String(publicConfig.PREVENT_LOCAL_OVERRIDE_KEYS ?? "")
        .split(",")
        .map((key) => key.trim())
        .filter((key) => key.length > 0)
        .forEach((key) => protectedKeys.add(key));
    }

    if (response?.status === 200) {
      for (const [key, value] of Object.entries(response.data)) {
        if (!protectedKeys.has(key)) {
          publicConfig[key] = value;
        }
      }
    }
  },
});
